import { useTheme } from '@mui/material/styles';
import { CardElement, CardElementProps } from '@recurly/react-recurly';
import { useMemo } from 'react';
import { makeStyles } from 'tss-react/mui';
import type { CSSObject } from 'tss-react';

type RecurlyCardElementProps = {
  error: boolean;
  onChange?: CardElementProps['onChange'];
};

const useStyles = makeStyles()((theme) => ({
  cardElement: {
    '& .recurly-element.recurly-element-card': {
      height: 56,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: 'inherit',
      borderColor: theme.palette.grey[400],
      marginTop: 0,
      '&.recurly-element-invalid': {
        borderColor: theme.palette.error.main,
      },
      '&.recurly-element-focus': {
        borderColor: theme.palette.grey[800],
      },
      '&:hover': {
        borderColor: theme.palette.grey[800],
      },
      ...theme.applyStyles('dark', {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.divider,
        '&.recurly-element-focus': {
          borderColor: theme.palette.text.primary,
        },
        '&:hover': {
          borderColor: theme.palette.text.primary,
        },
      }),
    },
  } as CSSObject,
  cardElementInvalid: {
    '& .recurly-element.recurly-element-card': {
      borderColor: theme.palette.error.main,
    },
  },
}));

export const RecurlyCardElement = (
  props: RecurlyCardElementProps,
): JSX.Element => {
  const { error, onChange } = props;
  const theme = useTheme();
  const { classes, cx } = useStyles();

  const cardStyles = useMemo(() => {
    const base = {
      fontFamily: theme.typography.fontFamily,
      fontColor: theme.palette.warmGrey[950],
      placeholder: {
        color: theme.palette.warmGrey[600],
      },
    };
    return error
      ? {
          ...base,
          fontColor: theme.palette.error.main,
          placeholder: { color: theme.palette.error.main },
        }
      : base;
  }, [error, theme]);

  return (
    <CardElement
      className={cx(classes.cardElement, error && classes.cardElementInvalid)}
      style={cardStyles}
      onChange={onChange}
    />
  );
};
